import { Control, FieldErrors, UseFormSetValue, UseFormTrigger, UseFormWatch } from "react-hook-form";
import { operacion } from "../../models/operacion";
import { TipoFuncionalidad, TipoProducto } from "../../../../utils/enums";
import ModalBuscadorTablas from "./modalBuscadorTablas";
import { useEffect, useState } from "react";
import { selectorTransversal } from "../../../../dtos/selector";
import { CalculoCuotaResponse, useTablasDesarrollo } from "../../hooks/useTablasDesarrollo";
import { useToast } from "../../../../hooks/useToast";
import { Card, CardContent, Grid2, Typography } from "@mui/material";
import MButton from "../../../../components/inputs/yup/materialui/mButton";
import InputText from "../../../../components/inputs/yup/materialui/inputText";
import InputNumber from "../../../../components/inputs/yup/materialui/inputNumber";
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import { TablaDesarrolloRow } from "../../../maestros/tablasDesarrollo/models/tablaDesarrolloRow";
import ModalGeneracionTablaDesarrollo from "../../../maestros/tablasDesarrollo/components/modalGenTablaDesarrollo";
import UseTablaDesarrollo from "../../../maestros/tablasDesarrollo/hooks/useTablaDesarrollo";
import { FormularioTablaDesarrolloDto } from "../../../maestros/tablasDesarrollo/models/formularioTablaDesarrollo";
import { useDetalleMutuoAccess } from "../../../../components/auth/DetalleMutuoPermissionGuard";

interface IPropsTablasDesarrolloForm {
    idMutuo: number;
    control: Control<operacion>;
    watch: UseFormWatch<operacion>;
    errors: FieldErrors<operacion>;
    trigger: UseFormTrigger<operacion>;
    setValue: UseFormSetValue<operacion>;
    isEditing: boolean;
    isComplementario: boolean;
    esVigente?: boolean;
    errorTablaCuotaMinima: boolean;
    errorTablaCuotaMaxima: boolean;
    setErrorTablaCuotaMinima: (error: boolean) => void;
    setErrorTablaCuotaMaxima: (error: boolean) => void;
}

const TablasDesarrolloForm: React.FC<IPropsTablasDesarrolloForm> = ({ idMutuo, control, watch, errors, trigger, setValue, isEditing, isComplementario, esVigente, errorTablaCuotaMinima, errorTablaCuotaMaxima, setErrorTablaCuotaMinima, setErrorTablaCuotaMaxima }) => {

    const dataFormOperacion = watch();
    const [showModalBuscador, setShowModalBuscador] = useState<boolean>(false);
    const [tablaSeleccionada, setTablaSeleccionada] = useState<TablaDesarrolloRow>();
    const [clickLupaCuotaMaxima, setClickLupaCuotaMaxima] = useState<boolean>(false);
    const [clickLupaCuotaMinima, setClickLupaCuotaMinima] = useState<boolean>(false);
    const [cuotaMinimaTabla, setCuotaMinimaTabla] = useState<CalculoCuotaResponse>();
    const [cuotaMaximaTabla, setCuotaMaximaTabla] = useState<CalculoCuotaResponse>();
    const [showModalCreacion, setShowModalCreacion] = useState<boolean>(false);

    const { calcularCuotasDesdeTablaDesarrollo } = useTablasDesarrollo();
    const { generarTabla } = UseTablaDesarrollo();
    const { addToast } = useToast();
    const { hasAccess: accessTableDev } = useDetalleMutuoAccess(
        esVigente,
        TipoFuncionalidad.Bandeja_editar
    );
    const incluyeTdMaxima = dataFormOperacion.tipoProducto === TipoProducto.MHF.toString();


    useEffect(() => {
        if (clickLupaCuotaMinima && tablaSeleccionada?.nombre) {

            setValue("tablaCuotaMinimaId", tablaSeleccionada.id);
            setValue("nombreTablaCuotaMinima", tablaSeleccionada.nombre)
            setValue("tasaTablaCuotaMinima", tablaSeleccionada.tasaanual ?? 0)
            setValue("plazoAnualTablaCuotaMinima", tablaSeleccionada.plazoanual);
            setValue("periodosGraciaCapitalTablaCuotaMinima", tablaSeleccionada.periodosgraciacapital);
            setValue("periodosGraciaCapitalInteresesTablaCuotaMinima", tablaSeleccionada.periodosgraciacapitalintereses);

            setValue("mesesGraciasK", tablaSeleccionada.periodosgraciacapital!);
            setValue("mesesGraciaKI", tablaSeleccionada.periodosgraciacapitalintereses!);
            setValue("plazoMaximo", tablaSeleccionada.plazoanual);
            setValue("tasaEmision", tablaSeleccionada.tasaanual!);

            trigger(["tasaEmision", "plazoMaximo", "mesesGraciasK", "mesesGraciaKI", "nombreTablaCuotaMinima"]);

            calcularCuotasDesdeTablaDesarrollo({
                TablaDesarrolloId: tablaSeleccionada.id!,
                MontoCredito: dataFormOperacion.montoCredito
            })
                .then((data: CalculoCuotaResponse | undefined) => {
                    if (data) {
                        setCuotaMinimaTabla(data!);
                        setErrorTablaCuotaMinima(false);
                    }
                    else {

                        setCuotaMinimaTabla({ valorCuota: 0, valorUltimaCuota: 0 });
                        setErrorTablaCuotaMinima(true);

                        addToast({
                            mostrar: true,
                            titulo: 'Error',
                            tipo: 'Danger',
                            mensaje: 'No fue posible recalcular la cuota mínima'
                        });
                    }
                });
        }

        if (clickLupaCuotaMaxima && tablaSeleccionada?.nombre) {

            setValue("tablaCuotaMaximaId", tablaSeleccionada.id);
            setValue("nombreTablaCuotaMaxima", tablaSeleccionada.nombre);
            setValue("tasaTablaCuotaMaxima", tablaSeleccionada.tasaanual)
            setValue("plazoAnualTablaCuotaMaxima", tablaSeleccionada.plazoanual);
            setValue("periodosGraciaCapitalTablaCuotaMaxima", tablaSeleccionada.periodosgraciacapital!);
            setValue("periodosGraciaCapitalInteresesTablaCuotaMaxima", tablaSeleccionada.periodosgraciacapitalintereses!);

            setValue("mesesGraciasK", tablaSeleccionada.periodosgraciacapital!);
            setValue("mesesGraciaKI", tablaSeleccionada.periodosgraciacapitalintereses!);
            setValue("plazoMinimo", tablaSeleccionada.plazoanual);
            setValue("tasaEmision", tablaSeleccionada.tasaanual!);

            trigger(["tasaEmision", "plazoMinimo", "mesesGraciasK", "mesesGraciaKI"]);

            calcularCuotasDesdeTablaDesarrollo({
                TablaDesarrolloId: tablaSeleccionada.id!,
                MontoCredito: dataFormOperacion.montoCredito,
            })
                .then((data: CalculoCuotaResponse | undefined) => {
                    if (data) {
                        setCuotaMaximaTabla(data!);
                        setErrorTablaCuotaMaxima(false);
                    }
                    else {

                        setCuotaMaximaTabla({ valorCuota: 0, valorUltimaCuota: 0 });
                        setErrorTablaCuotaMaxima(true);

                        addToast({
                            mostrar: true,
                            titulo: 'Error',
                            tipo: 'Danger',
                            mensaje: 'No fue posible recalcular la cuota máxima'
                        });
                    }
                });
        }

        setClickLupaCuotaMinima(false);
        setClickLupaCuotaMaxima(false);

    }, [tablaSeleccionada]
    );

    useEffect(() => {

        if (cuotaMinimaTabla) {
            setValue("cuotaMinima", cuotaMinimaTabla?.valorCuota);
            setValue("montoUltimoDividendo", cuotaMinimaTabla.valorUltimaCuota);
        }

    }, [cuotaMinimaTabla]);

    useEffect(() => {

        if (cuotaMaximaTabla) {
            setValue("cuotaMaxima", cuotaMaximaTabla?.valorCuota);
        }

    }, [cuotaMaximaTabla]);

    useEffect(() => {


        if (dataFormOperacion.montoCredito != undefined && dataFormOperacion.tablaCuotaMinimaId) {

            calcularCuotasDesdeTablaDesarrollo({
                TablaDesarrolloId: dataFormOperacion.tablaCuotaMinimaId!,
                MontoCredito: dataFormOperacion.montoCredito
            })
                .then((data: CalculoCuotaResponse | undefined) => {
                    if (data) {
                        setCuotaMinimaTabla(data!);
                        setErrorTablaCuotaMinima(false);
                    }
                    else {

                        setCuotaMinimaTabla({ valorCuota: 0, valorUltimaCuota: 0 });
                        setErrorTablaCuotaMinima(true);

                        addToast({
                            mostrar: true,
                            titulo: 'Error',
                            tipo: 'Danger',
                            mensaje: 'No fue posible recalcular la cuota mínima'
                        });
                    }
                });

        }

        if (dataFormOperacion.montoCredito != undefined && dataFormOperacion.tablaCuotaMaximaId) {

            calcularCuotasDesdeTablaDesarrollo({
                TablaDesarrolloId: dataFormOperacion.tablaCuotaMaximaId!,
                MontoCredito: dataFormOperacion.montoCredito
            })
                .then((data: CalculoCuotaResponse | undefined) => {
                    if (data) {
                        setCuotaMaximaTabla(data!);
                        setErrorTablaCuotaMaxima(false);
                    }
                    else {

                        setCuotaMaximaTabla({ valorCuota: 0, valorUltimaCuota: 0 });
                        setErrorTablaCuotaMaxima(true);

                        addToast({
                            mostrar: true,
                            titulo: 'Error',
                            tipo: 'Danger',
                            mensaje: 'No fue posible recalcular la cuota máxima'
                        });
                    }
                });
        }

    }, [dataFormOperacion.montoCredito]);

    useEffect(() => {

        if (dataFormOperacion.tipoProducto !== TipoProducto.MHT.toString())
            setValue("nombreTablaCuotaMaxima", dataFormOperacion.nombreTablaCuotaMaxima);

    }, [dataFormOperacion.tipoProducto]);

    const onCreate = async (e: FormularioTablaDesarrolloDto) => {
        const response = await generarTabla(e);
        if (response.status === 200 || response.status === 201) {
            addToast({
                mostrar: true,
                titulo: 'Confirmación',
                tipo: 'Success',
                mensaje: response.data.message,
            });
            const nuevaTabla: TablaDesarrolloRow = {
                id: response.data.tablaId,
                nombre: response.data.nombreTabla,
                periodosgraciacapitalintereses: e.periodoGraciaKI,
                periodosgraciacapital: e.periodoGraciaKI,
                fechaprotocolizacion: e.fechaProtocolizacion,
                numeroprotocolizacion: parseInt(e.numeroProtocolizacion ?? "0"),
                basetasa: undefined,
                fechaescrituracion: undefined,
                tasaanual: e.tasaAnual,
                plazoanual: e.plazoAnual
            }
            setTablaSeleccionada(nuevaTabla)
            setShowModalCreacion(false);
        }
    }

    return (

        <>

            <ModalBuscadorTablas
                idMutuo={idMutuo}
                show={showModalBuscador}
                onHide={() => setShowModalBuscador(false)}
                watchParentForm={watch}
                clickLupaCuotaMaxima={clickLupaCuotaMaxima}
                clickLupaCuotaMinima={clickLupaCuotaMinima}
                setTablaSeleccionada={setTablaSeleccionada}
            />

            <ModalGeneracionTablaDesarrollo
                show={showModalCreacion}
                onHide={() => { setShowModalCreacion(false) }}
                formularioDefecto={null}
                onCreate={onCreate}
                onUpdate={() => { }}
                watchParentForm={watch}
                idMutuo={null}
                asignarACuotaMinima={null}
            />

            <Grid2 container spacing={2}>
                <input {...control} type="hidden" name="tablaCuotaMinimaId" />
                <input {...control} type="hidden" name="tasaTablaCuotaMinima" />
                <input {...control} type="hidden" name="plazoAnualTablaCuotaMinima" />
                <input {...control} type="hidden" name="periodosGraciaCapitalTablaCuotaMinima" />
                <input {...control} type="hidden" name="periodosGraciaCapitalInteresesTablaCuotaMinima" />

                <input {...control} type="hidden" name="tablaCuotaMaximaId" />
                <input {...control} type="hidden" name="tasaTablaCuotaMaxima" />
                <input {...control} type="hidden" name="plazoAnualTablaCuotaMaxima" />
                <input {...control} type="hidden" name="periodosGraciaCapitalTablaCuotaMaxima" />
                <input {...control} type="hidden" name="periodosGraciaCapitalInteresesTablaCuotaMaxima" />

                <Grid2 size={{ xs: 12, lg: 3 }}>
                    <InputNumber
                        label="Plazo máximo (años)"
                        name="plazoMaximo"
                        control={control}
                        maxValue={999}
                        suffix="años"
                        error={errors.plazoMaximo}
                        readonly={!isEditing || isComplementario || esVigente}
                    />
                </Grid2>

                <Grid2 size={{ xs: 12, lg: 2 }}>
                    <InputText
                        label="Tabla cuota mínima"
                        name="nombreTablaCuotaMinima"
                        control={control}
                        error={errors.nombreTablaCuotaMinima}
                        // error={errors.nombreTablaCuotaMinima}
                        readonly
                    />
                    {!errors.nombreTablaCuotaMinima && errorTablaCuotaMinima && <p className="danger">La tabla presenta problemas para calcular la cuota mínima</p>}
                </Grid2>

                <Grid2 container size={{ xs: 12, lg: 3 }} sx={{ mt: 3 }}>
                    <MButton
                        type="button"
                        variant="contained"
                        title="Buscar tabla para cuota mínima"
                        disabled={!isEditing || !accessTableDev}
                        onClick={() => {
                            setClickLupaCuotaMaxima(false);
                            setClickLupaCuotaMinima(true);
                            setShowModalBuscador(true);
                        }}
                    >{<SearchIcon fontSize="small" />}
                    </MButton>

                    <MButton
                        type="button"
                        variant="contained"
                        title="Agregar tabla para cuota mínima"
                        disabled={!isEditing || !accessTableDev}
                        onClick={() => {
                            setClickLupaCuotaMaxima(false);
                            setClickLupaCuotaMinima(true);
                            setShowModalCreacion(true);
                        }}
                    >{<AddIcon fontSize="small" />}
                    </MButton>
                </Grid2>

                <Grid2 size={{ xs: 12, lg: 2 }} >
                    <InputNumber
                        label="Valor cuota mínima"
                        name="cuotaMinima"
                        control={control}
                        prefix="UF"
                        decimales={4}
                        readonly
                        error={errors.cuotaMinima}
                        maxValue={10000000000}
                    />
                </Grid2>

                {incluyeTdMaxima && (
                    <Grid2 size={{ xs: 12, lg: 3 }}>
                        <InputNumber
                            label="Plazo mínimo (años)"
                            name="plazoMinimo"
                            control={control}
                            suffix="años"
                            error={errors.plazoMinimo}
                            readonly={!isEditing || isComplementario || esVigente}
                        />
                    </Grid2>
                )}

                {incluyeTdMaxima && (
                    <Grid2 size={{ xs: 12, lg: 2 }}>
                        <InputText
                            label="Tabla cuota máxima"
                            name="nombreTablaCuotaMaxima"
                            control={control}
                            readonly
                            error={errors.nombreTablaCuotaMaxima}
                        />
                        {!errors.nombreTablaCuotaMaxima && errorTablaCuotaMaxima && <p className="danger">La tabla presenta problemas para calcular la cuota máxima</p>}
                    </Grid2>
                )}

                {incluyeTdMaxima && (
                    <Grid2 container size={{ xs: 12, lg: 3 }} sx={{ mt: 3 }}>
                        <MButton
                            type="button"
                            variant="contained"
                            title="Buscar tabla para cuota máxima"
                            disabled={!isEditing || !accessTableDev}
                            onClick={() => {
                                setClickLupaCuotaMaxima(true);
                                setClickLupaCuotaMinima(false);
                                setShowModalBuscador(true);
                            }}
                        >{<SearchIcon fontSize="small" />}
                        </MButton>

                        <MButton
                            type="button"
                            variant="contained"
                            title="Agregar tabla para cuota máxima"
                            disabled={!isEditing || !accessTableDev}
                            onClick={() => {
                                setClickLupaCuotaMaxima(true);
                                setClickLupaCuotaMinima(false);
                                setShowModalCreacion(true);
                            }}
                        >{<AddIcon fontSize="small" />}
                        </MButton>
                    </Grid2>
                )}

                {incluyeTdMaxima && (
                    <Grid2 size={{ xs: 12, lg: 2 }} >
                        <InputNumber
                            label='Valor cuota máxima'
                            name="cuotaMaxima"
                            control={control}
                            prefix="UF"
                            decimales={4}
                            readonly
                            error={errors.cuotaMaxima}
                            maxValue={10000000000}
                        />
                    </Grid2>
                )}
            </Grid2>

        </>
    );
}

export default TablasDesarrolloForm;